import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "form", "programName", "typeRadio", "typeOption"];
  static values = {
    baseUrl: String
  };

  connect() {
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  open(event) {
    event.preventDefault();

    const programId = event.currentTarget.dataset.programId;
    const programName = event.currentTarget.dataset.programName;
    const currentType = event.currentTarget.dataset.currentType;

    let convertibleTypes = [];
    try {
      convertibleTypes = JSON.parse(event.currentTarget.dataset.convertibleTypes || "[]");
    } catch (_e) {
      convertibleTypes = [];
    }

    const visibleTypes = [currentType, ...convertibleTypes];

    const formUrl = this.baseUrlValue.replace(':id', programId);
    this.formTarget.action = formUrl;

    this.programNameTarget.textContent = programName;

    this.typeOptionTargets.forEach(option => {
      const isVisible = visibleTypes.includes(option.dataset.typeValue);
      option.hidden = !isVisible;
    });

    this.typeRadioTargets.forEach(radio => {
      radio.checked = radio.value === currentType;
    });

    const modal = new Modal(this.modalTarget);
    modal.show();
  }

  _handleModalHidden() {
    this.typeRadioTargets.forEach(radio => {
      radio.checked = false;
    });
  }
}
